import cx from "classnames";
import React from "react";

import "./progress-bar.css";

export interface ProgressBarProps {
  value: number;
  displayPercentage?: boolean;
  percentagePosition?: "top" | "right";
  percentageWithColor?: boolean;
}

export const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(function ProgressBar(
  { value, displayPercentage = true, percentagePosition = "right", percentageWithColor = false },
  ref
) {
  const colors = {
    "progression-bar-red": value >= 0 && value < 25,
    "progression-bar-yellow": value >= 25 && value < 50,
    "progression-bar-lightgreen": value >= 50 && value < 75,
    "progression-bar-green": value >= 75,
    "progression-bar-complete": value === 100
  };

  const barNode = (
    <div className="progression-bar" ref={ref}>
      <div className={cx(colors)} style={{ width: `${value}%` }}></div>
    </div>
  );

  if (displayPercentage) {
    return (
      <div
        className={cx("progression-bar-wrapper", {
          "progression-bar-wrapper-top": percentagePosition === "top"
        })}
      >
        {barNode}
        <span
          className={cx("progression-bar-percentage text-right", {
            "progression-bar-percentage-colored": percentageWithColor,
            ...colors
          })}
        >
          {value}%
        </span>
      </div>
    );
  }

  return barNode;
});
